import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { VALIDATION_ROLE_OPTIONS } from '@/utils/exceptionality'
import type { ValidationRole } from '@/types/approval-flow.types'

interface Props {
  modelValue: ValidationRole | null
  disabled?: boolean
  error?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalRoleSelector',
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





const roleOptions = VALIDATION_ROLE_OPTIONS

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": _ctx.modelValue,
    items: _unref(roleOptions),
    "item-title": "label",
    "item-value": "value",
    label: "Papel validador",
    disabled: _ctx.disabled,
    error: _ctx.error,
    "error-messages": _ctx.error ? 'Selecione um papel validador' : undefined,
    density: "compact",
    variant: "outlined",
    "hide-details": "auto",
    style: {"width":"250px","min-width":"250px"},
    "bg-color": "white",
    "data-testid": "approval-role-selector",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => emit('update:modelValue', val))
  }, null, 8, ["model-value", "items", "disabled", "error", "error-messages"]))
}
}

})